import { useReportLike } from "lib/analytics/react/hooks";
import { useEffect, useState } from "react";
import { TYPO } from "styles/Typo";
import useSWR from "swr";
import { fetcher } from "utils/clientAPIs/fetcher";

function DiscussLikeButton({
  data,
  size = 28,
  from = "agenda",
}: {
  data: any;
  size?: number;
  from?: "agenda" | "floating";
}) {
  const [likeActive, setLikeActive] = useState(
    typeof window !== "undefined" &&
      localStorage?.getItem(`agenda_like_${data?.id}`) === "true"
  );
  const { data: likeCount, mutate } = useSWR(
    data?.id ? `/api/discuss/likeCount?discussId=${data?.id}` : null,
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: true,
      revalidateOnMount: true,
      revalidateOnBlur: false,
    }
  );
  const { trackLike } = useReportLike();

  const addLike = async (type: "add" | "delete") => {
    if (!data) return;
    try {
      const response: any = await fetch(
        `/api/discuss/likeCount?discussId=${data?.id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            isDelete: type === "delete",
          }),
        }
      );
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (typeof window !== "undefined") {
      setLikeActive(
        localStorage?.getItem(`agenda_like_${data?.id}`) === "true"
      );
    }
  }, [data?.id]);
  return (
    <div
      className="flex items-center gap-1 cursor-pointer"
      onClick={() => {
        trackLike(data?.id, likeActive);
        if (likeActive) {
          localStorage.removeItem(`agenda_like_${data?.id}`);
          addLike("delete");
          setLikeActive(false);

          // optimistic update
          mutate((prev: any) => {
            return prev - 1;
          }, false);
        } else {
          localStorage.setItem(`agenda_like_${data?.id}`, "true");
          addLike("add");
          setLikeActive(true);

          // optimistic update
          mutate((prev: any) => {
            return prev + 1;
          }, false);
        }
      }}
      data-gtm-id={`report-${from}-like-button`}
    >
      <LikeIcon fill={likeActive} size={size} />
      <p
        className={`${
          size === 28 ? TYPO.TYPO5_1_RG : TYPO.TYPO7_RG
        } text-gray30`}
      >
        {likeCount || 0}
      </p>
    </div>
  );
}
const LikeIcon = ({ fill, size }: { fill: boolean; size?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M13.9974 24.4998C13.7388 24.4998 13.4756 24.4531 13.2077 24.3596C12.9399 24.2661 12.7043 24.1164 12.5011 23.9107L10.5893 22.1434C8.63122 20.3293 6.8625 18.5293 5.28313 16.7432C3.70375 14.9572 2.91406 12.9888 2.91406 10.8381C2.91406 9.08014 3.49594 7.61205 4.65969 6.43383C5.82344 5.25561 7.27351 4.6665 9.0099 4.6665C9.98892 4.6665 10.9125 4.8769 11.7807 5.29769C12.6489 5.71848 13.3878 6.29357 13.9974 7.02294C14.607 6.29357 15.3459 5.71848 16.2141 5.29769C17.0823 4.8769 18.0059 4.6665 18.9849 4.6665C20.7213 4.6665 22.1714 5.25561 23.3351 6.43383C24.4989 7.61205 25.0807 9.08014 25.0807 10.8381C25.0807 12.9888 24.2957 14.9619 22.7255 16.7573C21.1554 18.5526 19.3728 20.3574 17.3778 22.1715L15.4936 23.9107C15.2905 24.1164 15.0549 24.2661 14.7871 24.3596C14.5192 24.4531 14.256 24.4998 13.9974 24.4998Z"
        fill={fill ? "var(--red40)" : "var(--gray30)"}
      />
    </svg>
  );
};

export default DiscussLikeButton;
